import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { Text, View } from "react-native";
import { convertDateToDDMMYYYY } from "ui/utils/dateUtils";
import { ProfileAvatar } from "app/components/atoms/ProfileAvatar";
import StatusFlagContent from "./StatusFlagContent";
import { DependencyIndicator } from "../atoms/DependencyIndicator";

interface Props {
  resident?: ResidentModel;
}

export default function ResidentContent({ resident }: Props) {
  return (
    <View className="flex flex-1 flex-col">
      <ProfileAvatar resident={resident} />
      <View className="flex-col gap-4 mt-5">
        <View className="flex flex-col sm:flex-row gap-4">
          {resident?.room?.name && (
            <View className="flex flex-1 flex-col py-3">
              <Text className="text-gray-600 mb-2">Room</Text>
              <Text>{resident.room.name}</Text>
            </View>
          )}
          {resident?.location?.name && (
            <View className="flex flex-1 flex-col py-3">
              <Text className="text-gray-600 mb-2">Location</Text>
              <Text>{resident.location.name}</Text>
            </View>
          )}
        </View>
        <View className="flex flex-col sm:flex-row gap-4">
          {resident?.dependency ? (
            <View className="flex flex-1 flex-col py-3 items-start">
              <Text className="text-gray-600 mb-2">Dependency</Text>
              <DependencyIndicator dependency={resident.dependency} />
            </View>
          ) : null}

          <View className="flex flex-1 flex-col py-3 items-start">
            <Text className="text-gray-600 mb-2">Status flags</Text>
            <StatusFlagContent resident={resident} />
          </View>
        </View>
        {resident?.admission_start_date && (
          <View className="flex flex-col py-3">
            <Text className="text-gray-600 mb-2">Check in</Text>
            <Text>{convertDateToDDMMYYYY(resident.admission_start_date)}</Text>
          </View>
        )}
      </View>
    </View>
  );
}
